import React from 'react'
import HeroSection from './HeroSection'
import WhyChooseSection from './WhyChooseSection'
import PremiumPrograms from './PremiumPrograms'
import ExperienceSection from './ExperienceSection'
import AchieveSection from './AchieveSection'
import SuccessStorySection from './SuccessStorySection'
import SuccessStoriesSection from './SuccessStoriesSection'
import InvestmentSection from './InvestmentSection'
import FaqSection from './FaqSection'
import ContactSection from './ContactSection'
import VideoTestimonials from './VideoTestimonials'


const index = () => {
  return (
    <div>
        <HeroSection/>
        <WhyChooseSection/>
        <PremiumPrograms/>
        <ExperienceSection/>
        <AchieveSection/>
        <SuccessStorySection/>
        {/* <InvestmentSection/> */}
        <VideoTestimonials/>
        <SuccessStoriesSection/>
        <FaqSection/>
        <ContactSection/>
    </div>
  )
}

export default index